import React, { useState } from 'react';

import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import GearsIcon from 'components/site-updating/gears-icon';

import {
  IStoreDiagnosticData,
  InternalStoreDiagnosticModal,
} from './internal-store-diagnostic-modal';
import { StoreIconWrap, UnstyledButtonNoSpacing } from './styled';

const messages = defineMessages({
  openStoreDiagnosticModal: {
    id: 'openStoreDiagnosticModal',
    defaultMessage: 'Open a diagnostic modal for this store',
    description:
      'A message to let internal RBI users know that clicking on this icon will open a diagnostic modal for the store.',
  },
});

const StyledGearIcon = styled(GearsIcon)`
  width: 1.25rem;
  height: 1.25rem;
`;

const DiagnosticCogIcon: React.FC<{ storeDiagnosticData: IStoreDiagnosticData | undefined }> = ({
  storeDiagnosticData,
}) => {
  const [showInternalDiagnosticsModal, setShowInternalDiagnosticsModal] = useState(false);

  const { formatMessage } = useIntl();

  const onModalDismiss = () => {
    setShowInternalDiagnosticsModal(false);
  };

  const onModalShow = () => {
    setShowInternalDiagnosticsModal(true);
  };

  return (
    <>
      <StoreIconWrap>
        <UnstyledButtonNoSpacing
          onClick={onModalShow}
          aria-label={formatMessage(messages.openStoreDiagnosticModal)}
        >
          <StyledGearIcon />
        </UnstyledButtonNoSpacing>
      </StoreIconWrap>
      {showInternalDiagnosticsModal && (
        <InternalStoreDiagnosticModal
          onModalDismiss={onModalDismiss}
          storeDiagnosticData={storeDiagnosticData}
        />
      )}
    </>
  );
};

export default DiagnosticCogIcon;
